import React from 'react'
import { Button, SearchInput, icons } from 'cdh-data-portal-theme'
import type { useStyles } from '../DataGovernorsPage.style'
import { localText } from './RegistryFilters.static'

export interface RegistryFiltersProps {
  readonly classes: ReturnType<typeof useStyles>['classes']
  readonly searchText: string
  readonly onSearchTextChange: (value: string) => void
  readonly onOpenFilters: () => void
}

export const RegistryFilters: React.FC<RegistryFiltersProps> = ({
  classes,
  searchText,
  onSearchTextChange,
  onOpenFilters,
}) => (
  <div className={classes.filterBarActions}>
    <SearchInput placeholder={localText.searchPlaceholder} searchText={searchText} setSearchText={onSearchTextChange} />
    <Button icon={icons.filterCompact} onClick={onOpenFilters} title={localText.filtersButton} variant="textDark" />
  </div>
)
